'use client'
import { useEffect } from 'react'

export default function UTMTracker() {
  useEffect(() => {
    // UTM params tracking
    const queryParamsStr = new URLSearchParams(window.location.search);
    if (queryParamsStr.get('utm_source') || queryParamsStr.get('utm_medium') ||
        queryParamsStr.get('utm_campaign') || queryParamsStr.get('utm_term') ||
        queryParamsStr.get('utm_content')) {
      localStorage.setItem('utm_incred_params', window.location.search);
    }

    // Push uses CleverTap SW only (/clevertap-sw.js). Do not register /sw.js here — it conflicts with push.
  }, [])

  return null // This component doesn't render anything
}